// extracted by mini-css-extract-plugin
module.exports = {"ScanSave":"ScanSave--GpYvK","header":"header--13WZg","content":"content--gxxZ9","wrap":"wrap--16pK5","tips":"tips--2U7fh"};